/**
 * @flow
 * Created by neo on 02.06.17.
 */

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import { translate  } from 'react-i18next';
import {Collapse, Row, Col, Card, CardBody, Label, FormGroup, Input, Button, FormFeedback} from 'reactstrap';
import TextField from '../Components/Form/TextField';
import Markdown from 'react-remarkable';

type Props = {
  client: any,
  onNext: () => void,
};

@observer
export class ClientInfo extends Component {


  constructor(props: Props) {
    super(props);

    this.state = {
      emailChanged: false,
    };
  }
  
  componentWillReceiveProps(nextProps: Props, nextContext: any) {

  }

  render() {
    const { client: contactInfo, t } = this.props;

    return (
      <Card className='h-100'>
        <CardBody>
          <h2>2. {t('Kontaktdaten')}</h2>
          <Row>
            <Col xs='12' md='6' >
              <TextField
                required
                label={t('Name')}
                onChange={(e) => contactInfo.updateLastName(e.target.value)}
                value={contactInfo.last_name}
              />
            </Col>
            <Col xs='12' md='6'>
              <TextField
                required
                label={t('Vorname')}
                onChange={(e) => contactInfo.updateFirstName(e.target.value)}
                value={contactInfo.first_name}
              />
            </Col>
          </Row>
        <Row>
              <Col xs='12' md='6'>
                <TextField
                  required
                  type='email'
                  label={t('E-Mail')}
                  onChange={(e) => contactInfo.email = e.target.value}
                  value={contactInfo.email}
                  error={!contactInfo.validEmail}
                  errorText={t('Email Adresse ist nicht gültig')}
                />
              </Col>
              <Col xs='12' md='6'>
                {!this.props.hidePhone && <TextField
                  required
                  label={t('Mobil / Telefon')}
                  onChange={(e) => contactInfo.phone = e.target.value}
                  value={contactInfo.phone}
                  error={!contactInfo.validPhone}
                  errorText={t('Phone number is not valid')}
                />}
              </Col>
            </Row>
          {!this.props.hideNote &&
              <Row>
                <Col>
                  <FormGroup>
                    <Label>
                      <Markdown>
                        {
                          contactInfo.flightOffer && contactInfo.flightOffer.is_transfer ?
                            t('Transfer flight remarks') :
                            t('Anmerkungen')
                        }
                      </Markdown>
                    </Label>
                    <Input type='textarea' name='note' onChange={(e) => contactInfo.note = e.target.value}
                           value={contactInfo.note} />
                  </FormGroup>
                </Col>
              </Row>
          }
        </CardBody>
      </Card>
    );
  }
}

export default translate ()(ClientInfo);




// WEBPACK FOOTER //
// ./src/App/Booking/ClientInfo.js